import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, Surface, Empty } from "../components/Primitives";

export default function Audit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit").then(r => setRows(r.data)); }, []);
  return (
    <div className="space-y-6">
      <PageHeader title="Journal d'audit" subtitle="Traçabilité complète"/>
      <Surface>
        {rows.length === 0 ? <Empty/> : (
          <table className="data-table">
            <thead><tr><th>Date</th><th>Utilisateur</th><th>Action</th><th>Entité</th><th>Détails</th></tr></thead>
            <tbody>
              {rows.map(r => (
                <tr key={r.id}>
                  <td className="font-data text-[var(--text-muted)] text-xs">{r.timestamp?.slice(0,19).replace("T"," ")}</td>
                  <td>{r.user_email}</td>
                  <td><span className="badge-info">{r.action}</span></td>
                  <td className="font-data text-[var(--text-muted)]">{r.entity}</td>
                  <td className="text-[var(--text-muted)] text-xs">{r.details || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Surface>
    </div>
  );
}
